
        var result = require("!!../../../../node_modules/css-loader/index.js!./my.matches.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/my.matches.component.css
// module id = 1236
// module chunks = 0